import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import AddControl from 'components/add_control';

export const Header = ({ addStep, workflow }) => {
  if (!workflow || workflow.steps.length === 0) {
    return null;
  }
  return (
      <>
      <h3 className="mt-0">Voucher Approval Workflow</h3>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <AddControl aria-label="add-step" onClick={addStep}>
          Add Step
        </AddControl>
      </div>
    </>
  );
};

Header.propTypes = {
  addStep: PropTypes.func.isRequired,
  workflow: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

const mapStateToProps = state => ({
  workflow: state.workflow
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);

